export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 px-4 md:px-6 lg:px-10 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-950 mb-3">
            关于午马
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            一个专注电视剧高清在线播放的平台
          </p>
        </div>

        <div className="bg-background-100 rounded-2xl border border-background-200 p-6 md:p-10">
          <div className="prose max-w-none">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              午马影院创建于热爱影视的团队之手，致力于为广大追剧爱好者提供一个纯净、高清、免费的电视剧在线观看平台。我们深知追剧人的痛点——广告弹窗、画质模糊、更新迟缓、资源不全……正因为感同身受，所以我们决心打造一个与众不同的追剧空间。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              平台目前已收录超过2000部热门电视剧，涵盖国产剧、韩剧、美剧、日剧、泰剧等多个品类，从古装传奇到都市情感，从悬疑刑侦到玄幻史诗，满足不同观众的口味偏好。所有剧集均经过精心筛选与优化，确保从第一集到大结局全程高清流畅不缓冲。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              我们坚持「不注册、不收费、不弹窗」的三不原则，同时保持与播出平台的同步更新节奏，让你在午马影院追剧的每一天都能轻松愉快。未来，我们将持续扩充片库、优化体验，努力成为你最信赖的追剧首选平台。
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6 mt-8 pt-8 border-t border-background-200">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">2000+</div>
              <div className="text-xs md:text-sm text-foreground-500 mt-1">热播剧集</div>
            </div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">1080P</div>
              <div className="text-xs md:text-sm text-foreground-500 mt-1">高清画质</div>
            </div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">百万+</div>
              <div className="text-xs md:text-sm text-foreground-500 mt-1">活跃追剧人</div>
            </div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">每日更新</div>
              <div className="text-xs md:text-sm text-foreground-500 mt-1">同步播出</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}